// extracted by mini-css-extract-plugin
export default {"input":"Settings_input__r8du3","bottom":"Settings_bottom__kcpCX","error":"Settings_error__+9ZQc","success":"Settings_success__PyP4u"};